/* eslint-disable no-bitwise */
import DataRoomService from 'app/common/services/dataroom';

const StringUtils = {
  format(
    templateString: string,
    templateVariables: Record<string, string>,
  ): string {
    let output = templateString;

    Object.keys(templateVariables).forEach((k) => {
      output = output.replace(`\${${k}}`, templateVariables[k]);
    });

    return output;
  },
  uuidv4(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;

      return v.toString(16);
    });
  },
  getDocumentDisplayName(node: TreeNode) {
    return `${`${node.number} ${node.name} ${node.code || ''}`.trim()}.${
      node.fileExtension
    }`;
  },
  createFileName(data: { number: string; name: string; code: string }) {
    return `${data.number || ''} ${data.name} ${
      data.code ? `(${data.code})` : ''
    }`.trim();
  },
  createFolderName(data: { number: string; name: string }) {
    return `${data.number || ''} ${data.name}`.trim();
  },
  createBulkRedactionLocalStorageKey(bulkRedactionId: string) {
    const { dataroomId, userId } = DataRoomService.session;

    return `BULK_REDACTION_${dataroomId}_${userId}_${bulkRedactionId}`;
  },
  createRedactionLocalStorageKey(redactionId: string) {
    const { dataroomId, userId } = DataRoomService.session;

    return `REDACTION_${dataroomId}_${userId}_${redactionId}`;
  },
  createImportLocalStorageKey(trackingId: string) {
    const { dataroomId, userId } = DataRoomService.session;

    return `IMPORT_DATAROOM_${dataroomId}_${userId}_${trackingId}`;
  },
  createRedactionSubmissionLocalStorageKey(redactionId: string) {
    const { dataroomId, userId } = DataRoomService.session;

    return `REDACTION_SUBMISSION_${dataroomId}_${userId}_${redactionId}`;
  },
  createRedactionEducationDialogKey() {
    const { dataroomId, userId } = DataRoomService.session;

    return `${dataroomId}_${userId}_DO_NOT_SHOW_EDUCATION_DIALOG_IN_REDACTION_TOOL`;
  },
  createLocalStorageKeyPerDataRoomAndUser(subject: string) {
    const { dataroomId, userId } = DataRoomService.session;

    return `${subject}_${dataroomId}_${userId}`;
  },
};

export default StringUtils;
